<template>
    <div id="pie-chart"></div>
</template>

<script>
  import * as d3 from "d3";

  export default {
    name: "PieChart",
    props: {
      data: Array
    },
    data: () => ({
      width: 1000,
      height: 500,
      name: '',
      value: '',
      color: d3.scaleOrdinal().range(["#98abc5", "#8a89a6", "#7b6888", "#6b486b", "#a05d56", "#d0743c", "#ff8c00"])
    }),
    mounted() {
      this.prepareKeys();
      this.renderChart();
    },
    methods: {
      getArcLabel() {
        const radius = Math.min(this.width, this.height) / 2 * 0.6;
        return d3.arc().innerRadius(radius).outerRadius(radius);
      },
      prepareKeys() {
        const dataKeys = Object.keys(this.data[0]);
        const isFirstNumber = this.data[0] && typeof this.data[0][0] === 'string';

        this.name = isFirstNumber ? dataKeys[1] : dataKeys[0];
        this.value = isFirstNumber ? dataKeys[0] : dataKeys[1];
      },
      renderChart: function () {
        const arc = d3.arc()
          .innerRadius(0)
          .outerRadius(Math.min(this.width, this.height) / 2 - 1);

        const arcs = d3.pie()
          .sort(null)
          .value(d => d[this.value])(this.data);

        const svg = d3.select("#pie-chart")
          .append("svg")
          .attr("viewBox", [-this.width / 2, -this.height / 2, this.width, this.height])
          .attr("id", "svg")
          .attr('height', this.height)
          .attr('width', this.width);

        svg
          .append("g")
          .attr("stroke", "white")
          .selectAll("path")
          .data(arcs)
          .join("path")
          .attr("fill", d => this.color(d.data[this.name]))
          .attr("d", arc)
          .append("title")
          .text(d => `${d.data[this.name]}: ${d.data[this.value].toLocaleString('ru')}`);

        svg.append("g")
          .attr("font-family", "sans-serif")
          .attr("font-size", 12)
          .attr("text-anchor", "middle")
          .selectAll("text")
          .data(arcs)
          .join("text")
          .attr("transform", d => `translate(${this.getArcLabel().centroid(d)})`)
          .call(text => text.append("tspan")
            .attr("y", "-0.4em")
            .attr("font-weight", "bold")
            .text(d => d.data[this.name]))
          .call(text => text.filter(d => (d.endAngle - d.startAngle) > 0.25).append("tspan")
            .attr("x", 0)
            .attr("y", "0.7em")
            .attr("fill-opacity", 0.7)
            .text(d => d.data[this.value].toLocaleString('ru')));


        return svg.node();
      }
    }
  }
</script>
